export default __webpack_public_path__ + "a6ed108462f39e4637fa760816ac5c1f.png";